var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1.3269633507853484 -1.35168 286.78523560209425 291.9224",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 3",
    id: "Ebene_3",
    style: {
      maxHeight: 500
    },
    width: 286.78523560209425,
    height: 291.9224,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 2,
    stroke: "#007bc0",
    fill: "none",
    d: "m31.9,142.3c0-61.1,49.5-110.6,110.5-110.6s110.6,49.5,110.6,110.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 2,
    stroke: "#007bc0",
    fill: "none",
    d: "m58.1,141.9c0-46.6,37.7-84.4,84.3-84.4s84.3,37.8,84.3,84.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 2,
    stroke: "#007bc0",
    fill: "none",
    d: "m277.3,142.5c0-74.6-60.4-135-134.9-135S7.5,67.9,7.5,142.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 10,
    stroke: "#717171",
    fill: "none",
    d: "m58.1,147.2c0,46.6,37.7,84.4,84.3,84.4s84.3-37.8,84.3-84.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 10,
    stroke: "#717171",
    fill: "none",
    d: "m277.3,146.6c0,74.5-60.4,135-134.9,135S7.6,221.2,7.6,146.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    strokeMiterlimit: 10,
    stroke: "#717171",
    fill: "none",
    d: "m31.9,146.8c0,61.1,49.5,110.6,110.5,110.6s110.5-49.5,110.5-110.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.7d52f392e8cab54cf16c042e90e32678.svg";
export { ForwardRef as ReactComponent };